import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _activity = { timestamp: 'google.protobuf.Timestamp' };
var _addFulfillerEmailWasSentActivityRequest = {};
var _addFulfillerEmailWasSentActivityResponse = {};
var _billingInfo = { paidDate: 'google.protobuf.Timestamp' };
var _bulkArchiveOrdersRequest = {};
var _bulkArchiveOrdersResponse = {};
var _bulkFulfillOrdersRequest = {};
var _bulkFulfillOrdersResponse = {};
var _bulkMarkOrdersAsPaidRequest = {};
var _bulkMarkOrdersAsPaidResponse = {};
var _bulkUnarchiveOrdersRequest = {};
var _bulkUnarchiveOrdersResponse = {};
var _createFulfillmentRequest = { fulfillment: '_fulfillment' };
var _createFulfillmentResponse = { order: '_order' };
var _createOrderRequest = { order: '_order' };
var _createOrderResponse = { order: '_order' };
var _declineOrderRequest = { eventTime: 'google.protobuf.Timestamp' };
var _declineOrderResponse = {};
var _deleteFulfillmentRequest = {};
var _deleteFulfillmentResponse = { order: '_order' };
var _fulfillment = { dateCreated: 'google.protobuf.Timestamp' };
var _getOrderRequestV2 = {};
var _getOrderResponseV2 = { order: '_order' };
var _markAsPaidRequest = {};
var _markAsPaidResponse = {};
var _markAsReadRequest = {};
var _markAsReadResponse = {};
var _order = {
    dateCreated: 'google.protobuf.Timestamp',
    lastUpdated: 'google.protobuf.Timestamp',
    billingInfo: '_billingInfo',
    shippingInfo: '_shippingInfo',
    activities: '_activity',
    fulfillments: '_fulfillment',
    refunds: '_refund',
};
var _queryOrdersRequestV2 = {};
var _queryOrdersResponseV2 = { orders: '_order' };
var _refund = { dateCreated: 'google.protobuf.Timestamp' };
var _sendFulfillmentConfirmationRequest = {};
var _sendFulfillmentConfirmationResponse = {};
var _setArchiveStatusRequest = {};
var _setArchiveStatusResponse = {};
var _setShippingFulfillmentRequest = {};
var _setShippingFulfillmentResponse = {};
var _shippingInfo = { deliverByDate: 'google.protobuf.Timestamp' };
var _updateFulfillmentRequest = {};
var _updateFulfillmentResponse = { order: '_order' };
var _updateOrderEmailRequest = {};
var _updateOrderEmailResponse = { order: '_order' };
var _updateOrderShippingAddressRequest = {};
var _updateOrderShippingAddressResponse = { order: '_order' };
function resolveWixOrdersApiV2OrdersV2Url(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/orders-reverse-proxy',
                destPath: '',
            },
        ],
        'ecom._base_domain_': [
            {
                srcPath: '/_api/orders-server/v2/orders',
                destPath: '/v2/orders',
            },
            {
                srcPath: '/_api/orders-server-reverse-proxy/v2/orders',
                destPath: '/v2/orders',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/orders-server/v2/orders',
                destPath: '/v2/orders',
            },
            {
                srcPath: '/_api/orders-server-reverse-proxy/v2/orders',
                destPath: '/v2/orders',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/stores/v2/orders',
                destPath: '/v2/orders',
            },
        ],
        _: [
            {
                srcPath: '/_api/orders-server/v2/orders',
                destPath: '/v2/orders',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveWixOrdersApiV2OrdersWriteApiUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/orders-reverse-proxy',
                destPath: '',
            },
        ],
        'ecom._base_domain_': [
            {
                srcPath: '/_api/orders-server/v2/orders',
                destPath: '/v2/orders',
            },
            {
                srcPath: '/_api/orders-server-reverse-proxy/v2/orders',
                destPath: '/v2/orders',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/orders-server/v2/orders',
                destPath: '/v2/orders',
            },
            {
                srcPath: '/_api/orders-server-reverse-proxy/v2/orders',
                destPath: '/v2/orders',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/stores/v2/orders',
                destPath: '/v2/orders',
            },
        ],
        _: [
            {
                srcPath: '/_api/orders-server/v2/orders',
                destPath: '/v2/orders',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveWixOrdersApiV2InternalOrdersV2Url(opts) {
    var domainToMappings = {};
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Add payment data for an order */
export function markAsPaid(payload) {
    var _a = serializer(_markAsPaidRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_markAsPaidResponse, {}).fromJSON;
    function __markAsPaid(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v2.orders',
            method: 'POST',
            methodFqn: 'wix.orders.api.v2.InternalOrdersV2.MarkAsPaid',
            url: resolveWixOrdersApiV2InternalOrdersV2Url({
                protoPath: '/v2/orders/{id}/markAsPaid',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __markAsPaid.fromReq = fromReq;
    __markAsPaid.__isAmbassador = true;
    return __markAsPaid;
}
/** Set order's shipping's fulfillment status */
export function setShippingFulfillment(payload) {
    var _a = serializer(_setShippingFulfillmentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_setShippingFulfillmentResponse, {}).fromJSON;
    function __setShippingFulfillment(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v2.orders',
            method: 'POST',
            methodFqn: 'wix.orders.api.v2.InternalOrdersV2.SetShippingFulfillment',
            url: resolveWixOrdersApiV2InternalOrdersV2Url({
                protoPath: '/v2/orders/{id}/setShippingFulfillment',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setShippingFulfillment.fromReq = fromReq;
    __setShippingFulfillment.__isAmbassador = true;
    return __setShippingFulfillment;
}
/** Send confirmation mail for either pickup/shipment fulfillment */
export function sendFulfillmentConfirmation(payload) {
    var _a = serializer(_sendFulfillmentConfirmationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_sendFulfillmentConfirmationResponse, {}).fromJSON;
    function __sendFulfillmentConfirmation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v2.orders',
            method: 'POST',
            methodFqn: 'wix.orders.api.v2.InternalOrdersV2.SendFulfillmentConfirmation',
            url: resolveWixOrdersApiV2InternalOrdersV2Url({
                protoPath: '/v2/orders/{id}/sendFulfillmentConfirmation',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __sendFulfillmentConfirmation.fromReq = fromReq;
    __sendFulfillmentConfirmation.__isAmbassador = true;
    return __sendFulfillmentConfirmation;
}
/** Mark order as read */
export function markAsRead(payload) {
    var _a = serializer(_markAsReadRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_markAsReadResponse, {}).fromJSON;
    function __markAsRead(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v2.orders',
            method: 'POST',
            methodFqn: 'wix.orders.api.v2.InternalOrdersV2.MarkAsRead',
            url: resolveWixOrdersApiV2InternalOrdersV2Url({
                protoPath: '/v2/orders/{id}/markAsRead',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __markAsRead.fromReq = fromReq;
    __markAsRead.__isAmbassador = true;
    return __markAsRead;
}
/** Set order's archive status */
export function setArchiveStatus(payload) {
    var _a = serializer(_setArchiveStatusRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_setArchiveStatusResponse, {}).fromJSON;
    function __setArchiveStatus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v2.orders',
            method: 'POST',
            methodFqn: 'wix.orders.api.v2.InternalOrdersV2.SetArchiveStatus',
            url: resolveWixOrdersApiV2InternalOrdersV2Url({
                protoPath: '/v2/orders/{id}/setArchiveStatus',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setArchiveStatus.fromReq = fromReq;
    __setArchiveStatus.__isAmbassador = true;
    return __setArchiveStatus;
}
/**
 * <blockquote class='warning'>
 *
 * __Deprecation Notice:__
 *
 * This endpoint has been replaced with
 * [eCommerce Create Order](https://dev.wix.com/docs/rest/api-reference/wix-e-commerce/orders/create-order)
 * and will be removed on September 4, 2024.
 *
 * </blockquote>
 *
 * Creates a new order.
 *
 * > **Notes:**
 * > + Only orders with the `paymentStatus` parameter set as `"PAID"` or `"NOT_PAID"` will show up in the site owner's Stores Orders tab in their dashboard.
 * > + The `billingInfo.paymentProviderTransactionId` and `billingInfo.paymentMethod` parameters can only be passed when paymentStatus is PAID.
 * > + The `billingInfo`.address parameter is required unless `channelInfo.type: "POS"`.
 * > + The `shippingInfo.shipmentDetails.address` parameter is required unless one of the following is true:
 * >   + The `shippingInfo.pickupDetails` is passed instead
 * >   + `channelInfo.type: "POS"`
 * >   + All order items are of type digital - `lineItems.lineItemType: "DIGITAL"`.
 * > + When passing `lineItems.variantId`, `lineItems.options` is required.
 * > + When passing `lineItems.productId`, `lineItem.lineItemType` is limited to `"PHYSICAL"`.
 * > + When not passing `lineItems.productId`, `lineItem.lineItemType` is limited to `"CUSTOM_AMOUNT_ITEM"`.
 * @deprecated Stores Create Order has been replaced with eCommerce Create Order., it has been replaced with com.wix.ecom.orders.v1.Orders.CreateOrder(), and will be removed on 2024-09-04.
 */
export function createOrder(payload) {
    var _a = serializer(_createOrderRequest, {
        _activity: _activity,
        _billingInfo: _billingInfo,
        _fulfillment: _fulfillment,
        _order: _order,
        _refund: _refund,
        _shippingInfo: _shippingInfo,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createOrderResponse, {
        _activity: _activity,
        _billingInfo: _billingInfo,
        _fulfillment: _fulfillment,
        _order: _order,
        _refund: _refund,
        _shippingInfo: _shippingInfo,
    }).fromJSON;
    function __createOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v2.orders',
            method: 'POST',
            methodFqn: 'wix.orders.api.v2.OrdersWriteAPI.CreateOrder',
            url: resolveWixOrdersApiV2OrdersWriteApiUrl({
                protoPath: '/v2/orders',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createOrder.fromReq = fromReq;
    __createOrder.__isAmbassador = true;
    return __createOrder;
}
export function bulkFulfillOrders(payload) {
    var _a = serializer(_bulkFulfillOrdersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkFulfillOrdersResponse, {}).fromJSON;
    function __bulkFulfillOrders(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v2.orders',
            method: 'POST',
            methodFqn: 'wix.orders.api.v2.OrdersWriteAPI.BulkFulfillOrders',
            url: resolveWixOrdersApiV2OrdersWriteApiUrl({
                protoPath: '/v2/orders/fulfill',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkFulfillOrders.fromReq = fromReq;
    __bulkFulfillOrders.__isAmbassador = true;
    return __bulkFulfillOrders;
}
export function bulkMarkOrdersAsPaid(payload) {
    var _a = serializer(_bulkMarkOrdersAsPaidRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkMarkOrdersAsPaidResponse, {}).fromJSON;
    function __bulkMarkOrdersAsPaid(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v2.orders',
            method: 'POST',
            methodFqn: 'wix.orders.api.v2.OrdersWriteAPI.BulkMarkOrdersAsPaid',
            url: resolveWixOrdersApiV2OrdersWriteApiUrl({
                protoPath: '/v2/orders/markAsPaid',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkMarkOrdersAsPaid.fromReq = fromReq;
    __bulkMarkOrdersAsPaid.__isAmbassador = true;
    return __bulkMarkOrdersAsPaid;
}
/** @deprecated It has been replaced with com.wix.ecom.orders.v1.Orders.BulkUpdateOrders(), and will be removed on 2025-03-02. */
export function bulkArchiveOrders(payload) {
    var _a = serializer(_bulkArchiveOrdersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkArchiveOrdersResponse, {}).fromJSON;
    function __bulkArchiveOrders(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v2.orders',
            method: 'POST',
            methodFqn: 'wix.orders.api.v2.OrdersWriteAPI.BulkArchiveOrders',
            url: resolveWixOrdersApiV2OrdersWriteApiUrl({
                protoPath: '/v2/orders/archive',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkArchiveOrders.fromReq = fromReq;
    __bulkArchiveOrders.__isAmbassador = true;
    return __bulkArchiveOrders;
}
export function bulkUnarchiveOrders(payload) {
    var _a = serializer(_bulkUnarchiveOrdersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUnarchiveOrdersResponse, {}).fromJSON;
    function __bulkUnarchiveOrders(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v2.orders',
            method: 'POST',
            methodFqn: 'wix.orders.api.v2.OrdersWriteAPI.BulkUnarchiveOrders',
            url: resolveWixOrdersApiV2OrdersWriteApiUrl({
                protoPath: '/v2/orders/unarchive',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUnarchiveOrders.fromReq = fromReq;
    __bulkUnarchiveOrders.__isAmbassador = true;
    return __bulkUnarchiveOrders;
}
export function addFulfillerEmailWasSentActivity(payload) {
    var _a = serializer(_addFulfillerEmailWasSentActivityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_addFulfillerEmailWasSentActivityResponse, {}).fromJSON;
    function __addFulfillerEmailWasSentActivity(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v2.orders',
            method: 'POST',
            methodFqn: 'wix.orders.api.v2.OrdersWriteAPI.AddFulfillerEmailWasSentActivity',
            url: resolveWixOrdersApiV2OrdersWriteApiUrl({
                protoPath: '/v2/orders/{orderId}/addFulfillerEmailWasActivitySent',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __addFulfillerEmailWasSentActivity.fromReq = fromReq;
    __addFulfillerEmailWasSentActivity.__isAmbassador = true;
    return __addFulfillerEmailWasSentActivity;
}
export function declineOrder(payload) {
    var _a = serializer(_declineOrderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_declineOrderResponse, {}).fromJSON;
    function __declineOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v2.orders',
            method: 'POST',
            methodFqn: 'wix.orders.api.v2.OrdersWriteAPI.DeclineOrder',
            url: resolveWixOrdersApiV2OrdersWriteApiUrl({
                protoPath: '/v2/orders/{orderId}/decline',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __declineOrder.fromReq = fromReq;
    __declineOrder.__isAmbassador = true;
    return __declineOrder;
}
/**
 * <blockquote class='warning'>
 *
 * __Deprecation Notice:__
 *
 * This endpoint has been replaced with
 * [eCommerce Update Order](https://dev.wix.com/docs/rest/api-reference/wix-e-commerce/orders/update-order)
 * and will be removed on September 4, 2024.
 *
 * </blockquote>
 *
 * Updates the email address of a specified order's billing info.
 * If shipping was selected as the delivery method, shipping info email will also be updated.
 * @deprecated Stores Update Order Email has been replaced with eCommerce Update Order., it has been replaced with com.wix.ecom.orders.v1.Orders.UpdateOrder(), and will be removed on 2024-09-04.
 */
export function updateOrderEmail(payload) {
    var _a = serializer(_updateOrderEmailRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateOrderEmailResponse, {
        _activity: _activity,
        _billingInfo: _billingInfo,
        _fulfillment: _fulfillment,
        _order: _order,
        _refund: _refund,
        _shippingInfo: _shippingInfo,
    }).fromJSON;
    function __updateOrderEmail(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v2.orders',
            method: 'PATCH',
            methodFqn: 'wix.orders.api.v2.OrdersWriteAPI.UpdateOrderEmail',
            url: resolveWixOrdersApiV2OrdersWriteApiUrl({
                protoPath: '/v2/orders/{orderId}/updateEmail',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateOrderEmail.fromReq = fromReq;
    __updateOrderEmail.__isAmbassador = true;
    return __updateOrderEmail;
}
/**
 * <blockquote class='warning'>
 *
 * __Deprecation Notice:__
 *
 * This endpoint has been replaced with
 * [eCommerce Update Order](https://dev.wix.com/docs/rest/api-reference/wix-e-commerce/orders/update-order)
 * and will be removed on September 4, 2024.
 *
 * </blockquote>
 *
 * Updates the shipping address of a specified order.
 * @deprecated Stores Update Order Shipping Address has been replaced with eCommerce Update Order., it has been replaced with com.wix.ecom.orders.v1.Orders.UpdateOrder(), and will be removed on 2024-09-04.
 */
export function updateOrderShippingAddress(payload) {
    var _a = serializer(_updateOrderShippingAddressRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateOrderShippingAddressResponse, { _activity: _activity, _billingInfo: _billingInfo, _fulfillment: _fulfillment, _order: _order, _refund: _refund, _shippingInfo: _shippingInfo }).fromJSON;
    function __updateOrderShippingAddress(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v2.orders',
            method: 'PUT',
            methodFqn: 'wix.orders.api.v2.OrdersWriteAPI.UpdateOrderShippingAddress',
            url: resolveWixOrdersApiV2OrdersWriteApiUrl({
                protoPath: '/v2/orders/{orderId}/updateShippingAddress',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateOrderShippingAddress.fromReq = fromReq;
    __updateOrderShippingAddress.__isAmbassador = true;
    return __updateOrderShippingAddress;
}
/**
 * <blockquote class='warning'>
 *
 * __Deprecation Notice:__
 *
 * This endpoint has been replaced with
 * [eCommerce Get Order](https://dev.wix.com/docs/rest/api-reference/wix-e-commerce/orders/get-order)
 * and will be removed on September 4, 2024.
 *
 * </blockquote>
 *
 * Returns an order with the provided ID.
 * @deprecated Stores Get Order has been replaced with eCommerce Get Order., it has been replaced with com.wix.ecom.orders.v1.Orders.GetOrder(), and will be removed on 2024-09-04.
 */
export function getOrder(payload) {
    var _a = serializer(_getOrderRequestV2, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getOrderResponseV2, {
        _activity: _activity,
        _billingInfo: _billingInfo,
        _fulfillment: _fulfillment,
        _order: _order,
        _refund: _refund,
        _shippingInfo: _shippingInfo,
    }).fromJSON;
    function __getOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v2.orders',
            method: 'GET',
            methodFqn: 'wix.orders.api.v2.OrdersV2.GetOrder',
            url: resolveWixOrdersApiV2OrdersV2Url({
                protoPath: '/v2/orders/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getOrder.fromReq = fromReq;
    __getOrder.__isAmbassador = true;
    return __getOrder;
}
/**
 * <blockquote class='warning'>
 *
 * __Deprecation Notice:__
 *
 * This endpoint has been replaced with
 * [eCommerce Search Orders](https://dev.wix.com/docs/rest/api-reference/wix-e-commerce/orders/search-orders)
 * and will be removed on September 4, 2024.
 *
 * </blockquote>
 *
 * Returns a list of up to 100 orders, given the provided paging, sorting and filters.
 * See [Stores Pagination](https://dev.wix.com/api/rest/wix-stores/pagination) for more information.
 * Hidden orders are not returned.
 * @deprecated Stores Query Orders has been replaced with eCommerce Search Orders., it has been replaced with com.wix.ecom.orders.v1.Orders.SearchOrders(), and will be removed on 2024-09-04.
 */
export function queryOrders(payload) {
    var _a = serializer(_queryOrdersRequestV2, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryOrdersResponseV2, {
        _activity: _activity,
        _billingInfo: _billingInfo,
        _fulfillment: _fulfillment,
        _order: _order,
        _refund: _refund,
        _shippingInfo: _shippingInfo,
    }).fromJSON;
    function __queryOrders(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v2.orders',
            method: 'POST',
            methodFqn: 'wix.orders.api.v2.OrdersV2.QueryOrders',
            url: resolveWixOrdersApiV2OrdersV2Url({
                protoPath: '/v2/orders/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryOrders.fromReq = fromReq;
    __queryOrders.__isAmbassador = true;
    return __queryOrders;
}
/** Temp method for analytics migration */
export function queryOrdersEventuallyConsistent(payload) {
    var _a = serializer(_queryOrdersRequestV2, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryOrdersResponseV2, {
        _activity: _activity,
        _billingInfo: _billingInfo,
        _fulfillment: _fulfillment,
        _order: _order,
        _refund: _refund,
        _shippingInfo: _shippingInfo,
    }).fromJSON;
    function __queryOrdersEventuallyConsistent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v2.orders',
            method: 'POST',
            methodFqn: 'wix.orders.api.v2.OrdersV2.QueryOrdersEventuallyConsistent',
            url: resolveWixOrdersApiV2OrdersV2Url({
                protoPath: '/v2/orders/query/RO',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryOrdersEventuallyConsistent.fromReq = fromReq;
    __queryOrdersEventuallyConsistent.__isAmbassador = true;
    return __queryOrdersEventuallyConsistent;
}
/**
 * <blockquote class='warning'>
 *
 * __Deprecation Notice:__
 *
 * This endpoint has been replaced with
 * [eCommerce Create Fulfillment](https://dev.wix.com/docs/rest/api-reference/wix-e-commerce/order-fulfillments/create-fulfillment)
 * and will be removed on September 4, 2024.
 *
 * </blockquote>
 *
 * Creates a fulfillment (a subset of an order, with line items that are being shipped together) based on the body parameters passed with the request.
 * If the site owner has requested it, calling this request will trigger an email to the customer (based on the Wix store settings).
 * @deprecated Stores Create Fulfillment has been replaced with eCommerce Create Fulfillment., it has been replaced with com.wix.ecom.orders.fulfillments.v1.Fulfillments.CreateFulfillment(), and will be removed on 2024-09-04.
 */
export function createFulfillment(payload) {
    var _a = serializer(_createFulfillmentRequest, { _fulfillment: _fulfillment }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createFulfillmentResponse, {
        _activity: _activity,
        _billingInfo: _billingInfo,
        _fulfillment: _fulfillment,
        _order: _order,
        _refund: _refund,
        _shippingInfo: _shippingInfo,
    }).fromJSON;
    function __createFulfillment(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v2.orders',
            method: 'POST',
            methodFqn: 'wix.orders.api.v2.OrdersV2.CreateFulfillment',
            url: resolveWixOrdersApiV2OrdersV2Url({
                protoPath: '/v2/orders/{orderId}/fulfillments',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createFulfillment.fromReq = fromReq;
    __createFulfillment.__isAmbassador = true;
    return __createFulfillment;
}
/**
 * <blockquote class='warning'>
 *
 * __Deprecation Notice:__
 *
 * This endpoint has been replaced with
 * [eCommerce Update Fulfillment](https://dev.wix.com/docs/rest/api-reference/wix-e-commerce/order-fulfillments/update-fulfillment)
 * and will be removed on September 4, 2024.
 *
 * </blockquote>
 *
 * Updates an existing fulfillment.
 * @deprecated Stores Update Fulfillment has been replaced with eCommerce Update Fulfillment., it has been replaced with com.wix.ecom.orders.fulfillments.v1.Fulfillments.UpdateFulfillment(), and will be removed on 2024-09-04.
 */
export function updateFulfillment(payload) {
    var _a = serializer(_updateFulfillmentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateFulfillmentResponse, {
        _activity: _activity,
        _billingInfo: _billingInfo,
        _fulfillment: _fulfillment,
        _order: _order,
        _refund: _refund,
        _shippingInfo: _shippingInfo,
    }).fromJSON;
    function __updateFulfillment(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v2.orders',
            method: 'PUT',
            methodFqn: 'wix.orders.api.v2.OrdersV2.UpdateFulfillment',
            url: resolveWixOrdersApiV2OrdersV2Url({
                protoPath: '/v2/orders/{orderId}/fulfillments/{fulfillmentId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateFulfillment.fromReq = fromReq;
    __updateFulfillment.__isAmbassador = true;
    return __updateFulfillment;
}
/**
 * <blockquote class='warning'>
 *
 * __Deprecation Notice:__
 *
 * This endpoint has been replaced with
 * [eCommerce Delete Fulfillment](https://dev.wix.com/docs/rest/api-reference/wix-e-commerce/order-fulfillments/delete-fulfillment)
 * and will be removed on September 4, 2024.
 *
 * </blockquote>
 *
 * Deletes an existing fulfillment.
 * @deprecated Stores Delete Fulfillment has been replaced with eCommerce Delete Fulfillment., it has been replaced with com.wix.ecom.orders.fulfillments.v1.Fulfillments.DeleteFulfillment(), and will be removed on 2024-09-04.
 */
export function deleteFulfillment(payload) {
    var _a = serializer(_deleteFulfillmentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteFulfillmentResponse, {
        _activity: _activity,
        _billingInfo: _billingInfo,
        _fulfillment: _fulfillment,
        _order: _order,
        _refund: _refund,
        _shippingInfo: _shippingInfo,
    }).fromJSON;
    function __deleteFulfillment(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v2.orders',
            method: 'DELETE',
            methodFqn: 'wix.orders.api.v2.OrdersV2.DeleteFulfillment',
            url: resolveWixOrdersApiV2OrdersV2Url({
                protoPath: '/v2/orders/{orderId}/fulfillments/{fulfillmentId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteFulfillment.fromReq = fromReq;
    __deleteFulfillment.__isAmbassador = true;
    return __deleteFulfillment;
}
//# sourceMappingURL=http.impl.js.map